import angular from 'angular';
import constants from 'app/constants';
import {
  loaderService,
  ssDialogService,
  vmDataService,
} from 'app/services';
import controller from './edit-contact-dialog.controller';
import template from './edit-contact-dialog.html';
import validator, { name as validatorName } from './messages/unique-contact-name.validator.directive';
import contactNameMessagesTpl from './messages/contact.name.messages.html';
import contactPhoneMessagesTpl from './messages/contact.phone.messages.html';
import contactEmailMessagesTpl from './messages/contact.email.messages.html';


class dialogService {
  getOptions($event, { contact, addCallback, editCallback }) {
    return {
      controller,
      controllerAs: 'editContactDialogVM',
      locals: {
        contact,
        addCallback,
        editCallback
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.vendorManagement.editContactDialog', [
  constants,
  loaderService,
  ssDialogService,
  vmDataService,
])
  .directive(validatorName, validator)
  .service('editContactDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('contact.name.messages.html', contactNameMessagesTpl);
    $templateCache.put('contact.phone.messages.html', contactPhoneMessagesTpl);
    $templateCache.put('contact.email.messages.html', contactEmailMessagesTpl);
  })
  .name;
